import { StatusDoFechamento } from './enum';

export class FechamentoFinanceiro {
  id: number;
  idFornecedor: number;
  fornecedor: string;
  data: Date;
  idFuncionario: number;
  funcionario: string;
  status: StatusDoFechamento;
  statusDescricao: string;
  arquivo: string;
  obs: string;
  qtdPedidos: number;
  valor: number;
  pedidos: string[];
  dataStatus: Date;
  nPedidos: string;
}
